/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/purchase_order_statuses-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/purchase_order_statuses-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/purchase_order_statuses-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-purchase_order_statuses-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/purchase_order_statuses.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-29T23:22:39.737Z
 * Source config: config/entities/purchase_order_statuses-entity-config.ts
 * Public fields: 12/12 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const PurchaseOrderStatusesSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  name: Type.String(), // name field
  code: Type.String(), // code field
  color: Type.String(), // color field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  is_default: Type.Union([Type.Boolean(), Type.Null()]), // is_default field
  is_active: Type.Union([Type.Boolean(), Type.Null()]), // is_active field
  sort_order: Type.Union([Type.Number(), Type.Null()]), // sort_order field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field - auto-managed timestamp
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field - auto-managed timestamp
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

export const CreatePurchaseOrderStatusesSchema = Type.Object({
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  name: Type.String(), // name field
  code: Type.String(), // code field
  color: Type.String(), // color field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  is_default: Type.Union([Type.Boolean(), Type.Null()]), // is_default field
  is_active: Type.Union([Type.Boolean(), Type.Null()]), // is_active field
  sort_order: Type.Union([Type.Number(), Type.Null()]), // sort_order field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

export const UpdatePurchaseOrderStatusesSchema = Type.Object({
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  name: Type.String(), // name field
  code: Type.String(), // code field
  color: Type.String(), // color field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  is_default: Type.Union([Type.Boolean(), Type.Null()]), // is_default field
  is_active: Type.Union([Type.Boolean(), Type.Null()]), // is_active field
  sort_order: Type.Union([Type.Number(), Type.Null()]), // sort_order field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type PurchaseOrderStatusesRow = Static<typeof PurchaseOrderStatusesSchema>;
export type PurchaseOrderStatusesInsert = Static<typeof CreatePurchaseOrderStatusesSchema>;
export type PurchaseOrderStatusesUpdate = Static<typeof UpdatePurchaseOrderStatusesSchema>;

// Legacy type aliases for backward compatibility
export type PurchaseOrderStatuses = PurchaseOrderStatusesRow;
export type CreatePurchaseOrderStatuses = PurchaseOrderStatusesInsert;
export type UpdatePurchaseOrderStatuses = Static<typeof UpdatePurchaseOrderStatusesSchema>;

// Field configuration metadata
export const PurchaseOrderStatusesFieldConfig = {
  filterable: ['id', 'organization_id', 'is_default', 'is_active'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['organization_id', 'name', 'code', 'color'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface PurchaseOrderStatusesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface PurchaseOrderStatusesResponse {
  data: PurchaseOrderStatuses[] | null;
  error: Error | null;
  count?: number;
}

export interface SinglePurchaseOrderStatusesResponse {
  data: PurchaseOrderStatuses | null;
  error: Error | null;
}
